<template>
  <div>
    <div class="services-box">
      <div v-for="(service, i) in mtech[leg].services" :key="i" @click="selectService(service)"
        :class="['service-box d-flex', {
          active: selectedService === service.code, disabled: serviceLoading || rsvpData.luggage > service.maxLuggageVal,
          show: (!selectedService || (selectedService && selectedService === service.code)) && rsvpData.passenger <= service.maxPaxVal
        }]"
        v-show="(!selectedService || (selectedService && selectedService === service.code)) && rsvpData.passenger <= service.maxPaxVal"
      >
        <span v-show="false">{{selectedService}} -- {{service.code}} -- {{rsvpData.passenger}}-{{service.maxPaxVal}}</span>
        <div class="car-img">
          <img :src="service.img" />
        </div>
        <div class="car-desc d-flex flex-column flex-grow-1">
          <div class="capacity-box">
            <div class="capacity">
              <div class="fa-stack">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-user fa-stack-1x fa-inverse"></i>
              </div>
              <span>{{service.maxPax}}</span>
            </div>
            <div :class="['capacity', {exceed:rsvpData.luggage > service.maxLuggageVal}]">
              <div class="fa-stack">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-suitcase fa-stack-1x fa-inverse"></i>
              </div>
              <span>{{service.maxLuggage}}</span>
            </div>
          </div>
          <div class="service-name">{{service.desc}}</div>
          <div class="sub-info" v-if="service.cancellation">
            <i class="fas fa-history"></i>
            {{service.cancellation}}
          </div>
          <div class="sub-info" v-if="service.pricePax">
            <i class="far fa-money-bill-alt"></i>
            {{service.pricePax}}
          </div>
          <div class="sub-info" v-if="service.paxStandard">
            <i class="fas fa-suitcase"></i>
            {{service.paxStandard}}
          </div>
        </div>
        <div class="car-price d-flex flex-column">
          <div class="price">
            <span v-if="!serviceDisable(service)">${{ (service.price.baseFare + service.price.addMarkup - service.price.discountVal).toFixed(2) }}</span>
            <span v-else>{{ $t('serviceSelect.NA') }}</span>
          </div>
          <i class="appFees">{{ $t('serviceSelect.plusAppFees') }}</i>
          <div class="discount d-flex align-center" v-if="!serviceDisable(service)">
            <div class="old-price">${{ (service.price.baseFare + service.price.addMarkup).toFixed(2)}}</div>
            <div class="dc-price">{{ $t('serviceSelect.save') }} ${{service.price.discountVal.toFixed(2)}}</div>
          </div>
          <div :class="['suggested-pickup-time']" @click.stop
            v-if="(rsvpData.isAirportPickup || rsvpData.isAirportDropoff) && suggestedPickupTime(service.code).val && !charter.enabled">
            {{ $t('serviceSelect.pickupDate') }}
            <a @click="customPickupTime(service.code)"><!-- v-if="!suggestedPickupTime(service.code).mtechDate" -->
              {{ mtech[leg].pickupDate || suggestedPickupTime(service.code).val }}
              <i class="fas fa-edit"></i>
            </a>
          </div>
          <div class="dropoff-time" v-if="showBtt && !charter.enabled">{{ $t('serviceSelect.dropoffTime') }} {{ eta(service.code).dropoffTime }}</div>
        </div>
      </div>
      <div v-if="!Object.keys(mtech[leg].services).length" class="empty-service">
        {{ $t('serviceSelect.noService') }}
      </div>
    </div>
  </div>
</template>
<script>
/* // global CONFIG */
import moment from 'moment-timezone'
import featureToggle from '@/modules/api/featureToggle'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'services',
  props: ['leg'],
  data () {
    return {
      disabledServices: [],
      offsets: {}
    }
  },
  computed: {
    currentBrand () { return this.$store.state.brandCode },
    rsvp () { return this.$store.state.reservation },
    rsvpData () { return this.rsvp[this.leg] },
    loading () { return this.rsvp.serviceLoading },
    mtech () { return this.rsvp.mtech },
    selectedService () { return this.rsvpData.selectedService },
    serviceLoading () { return this.$store.state.reservation.serviceLoading },
    _pax () { return this.rsvpData.passenger },
    _luggage () { return this.rsvpData.luggage },
    _pickupTimeOffsets () { return this.$settings.get('PickupTimeOffsets') },
    showBtt () {
      if (this.rsvpData.isAirportPickup || this.rsvpData.isAirportDropoff) {
        return this.rsvpData.flightDate && this.rsvpData.airline && this.rsvpData.flightNo
      }
      return true
    },
    charter () { return this.$store.state.reservation.charter },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    serviceDisable (service) {
      return this.rsvpData.passenger > service.maxPaxVal ||
        this.rsvpData.luggage > service.maxLuggageVal
    },
    selectService (service) {
      if (
        this.rsvpData.passenger > service.maxPaxVal ||
        this.rsvpData.luggage > service.maxLuggageVal
      ) {
        return
      }

      this.$store.commit('reservation/setSelectedService', {
        leg: this.leg,
        value: service.code
      })
      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        gtag('event', `Service_MTECH_${service.desc}`) // eslint-disable-line
      }

      let self = this
      this.$nextTick().then(() => {
        self.$forceUpdate()
      })

      let leg1 = this.$store.state.reservation.leg1
      if (leg1.selectedService && self.mtech.leg1.services[leg1.selectedService].pickupTimes &&
        self.mtech.leg1.services[leg1.selectedService].pickupTimes.length
      ) {
        self.$store.commit('reservation/setMtechLegData', {
          leg: 'leg1',
          fields: {
            pickupDate: moment(self.mtech.leg1.services[leg1.selectedService].pickupTimes[0].unix, 'X').tz(leg1.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          }
        })
      }

      this.getQuoteMtechService()
    },
    suggestedPickupTime (service, bypass = false) {
      let rsvp = this.rsvp
      if (!rsvp.suggestedTime[this.leg].time) { return '' }
      let serviceData = this.mtech[this.leg].services[service]
      if (serviceData && serviceData.pickupTimes.length) {
        this.$store.commit('serviceSelection/setSuggestedTime', moment(serviceData.pickupTimes[0].unix, 'X').tz(this.rsvpData.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)))
        return {
          val: moment(serviceData.pickupTimes[0].unix, 'X').tz(this.rsvpData.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)),
          // isAllowed: true,
          mtechDate: true
        }
      }

      let timezone = rsvp[this.leg].timezone
      let date = moment(rsvp.suggestedTime[this.leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let _date = moment.tz(rsvp.suggestedTime[this.leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false), timezone)
      if (rsvp[this.leg].isAirportPickup) {
        let delay = rsvp.suggestedTime[this.leg].isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay'
        date.add(this.$settings.get(delay), 'minutes')
      } else if (rsvp[this.leg].isAirportDropoff) {
        let delay = rsvp.suggestedTime[this.leg].isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer'
        let eta = Math.ceil(rsvp[this.leg].eta / 60)
        let btt = Math.ceil(eta * 1.15)

        // if (this.rsvp[this.leg].services[service].isShared) {
        //   btt = Math.ceil(eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100)))
        //   btt = (btt - (btt % 5)) + 5
        // }

        let timeDelay = Math.ceil(parseFloat(this.$settings.get(delay)))
        date.subtract(timeDelay + btt, 'minutes')
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
        _date.subtract(timeDelay + btt, 'minutes')
        _date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
      }

      if (rsvp.customPickupTime[this.leg] && !bypass) {
        date = moment(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        _date = moment.tz(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false), timezone)
      } else {
        if (this.offsets['a' + date.format('e')] && rsvp[this.leg].isAirportDropoff) {
          let found = false
          this.offsets['a' + date.format('e')].forEach(function (data, index) {
            let time = moment(date.format('HHmm'), 'HHmm')
            let start = moment(data.start, 'HHmm')
            let end = moment(data.end, 'HHmm')
            if (time.isBetween(start, end) && !found) {
              found = true
              if (data.value.indexOf('-') > -1) {
                date.subtract(data.value.substring(1, data.value.length), 'minutes')
                _date.subtract(data.value.substring(1, data.value.length), 'minutes')
              } else {
                date.add(data.value, 'minutes')
                _date.add(data.value, 'minutes')
              }
            }
          })
        }
      }
      return {
        val: date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)),
        // isAllowed: !_date.isBefore(moment().tz(timezone).add(this.$settings.get('WebTimeBuffer'), 'minutes')),
        mtechDate: false
      }
    },
    customPickupTime (code) {
      let self = this
      if (self.serviceDisable(code)) { return }

      self.$store.commit('reservation/setActiveLeg', self.leg)
      self.$store.commit('serviceSelection/setSuggestedTime', this.suggestedPickupTime(code, true).val)
      self.$store.commit('serviceSelection/setForPickupDate', true)
      self.$store.commit('serviceSelection/setCustomPickupDateDefault', this.suggestedPickupTime(code).val)
      self.$store.commit('serviceSelection/showDateTimePicker')
    },
    eta (service) {
      let rsvp = this.rsvp
      let minutesAway = rsvp.serviceEta[service]
      let eta = Math.ceil(rsvp[this.leg].eta / 60)
      let btt = eta * 1.15

      let dropoffTime = moment().tz(rsvp[this.leg].timezone)
      if (this.mtech[this.leg].pickupDate) {
        dropoffTime = moment(this.mtech[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      } else if (this.selectedService) {
        dropoffTime = moment(this.mtech[this.leg].services[this.selectedService].pickupTimes[0].unix, 'X')
      }
      dropoffTime = dropoffTime.add(btt, 'minutes')
      return {
        minutesAway: parseInt(minutesAway || 999),
        dropoffTime: dropoffTime.format(featureToggle.timeFormat(this, false))
      }
    },
    setPickupTimeOffsets () {
      let self = this
      let PickupTimeOffsets = this.$settings.get('PickupTimeOffsets')
      if (PickupTimeOffsets) {
        let split = PickupTimeOffsets.split(',')
        split.forEach(function (val, index) {
          if (!self.offsets['a' + val.substring(0, 1)]) {
            self.offsets['a' + val.substring(0, 1)] = []
          }
          self.offsets['a' + val.substring(0, 1)].push({
            start: val.substring(1, 5),
            end: val.substring(5, 9),
            value: val.substring(9, val.length)
          })
        })
      }
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.$store.state.reservation[this.leg]

      let pickupDate = rsvpData.pickupDate
      if (rsvpData.flightDate && (rsvpData.isAirportDropoff || rsvpData.isAirportPickup)) {
        pickupDate = rsvpData.flightDate
      }
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.$store.state.reservation.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
        }
      }, '2.0')
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    }
  },
  watch: {
    _luggage (val) {
      if (this.selectedService) {
        let service = this.mtech[this.leg].services[this.selectedService]
        if (val > service.maxLuggageVal) {
          this.$store.commit('reservation/setSelectedService', {
            leg: this.leg,
            value: ''
          })
        }
      }
    },
    _pickupTimeOffsets: function (value) {
      if (value) {
        this.setPickupTimeOffsets()
      }
    }
  },
  mounted () {
    this.setPickupTimeOffsets()
  }
}
</script>

<style lang="scss" scoped>
.services-box{
  margin: 10px 0;
  padding: 15px;
  background: #f6f6f6;
  border-radius: 6px;
}
.service-box{
  position: relative;
  max-height: 999px;
  border: 2px solid #ccc;
  border-radius: 3px;
  background: #fff;
  margin-bottom: 20px;
  cursor: pointer;

  &:hover:not(.disabled), &.active { border: 2px solid #923BBD; }
  &.disabled{
    opacity: .65;
    cursor: default;
  }
  &:not(.show){
    display:none!important;
  }
  .car-img{
    background: #d0d0d0;
    max-width: 150px;
    display: flex;
    align-items: center;

    img{
      height: fit-content;
    }
  }
  .car-desc{
    padding: 10px 15px;

    .capacity-box{
      margin-bottom: 20px;
    }
    .capacity{
      display: inline-block;
      color: #7a7a7a;

      &:first-child{
        margin-right: 15px;
      }
      &.exceed{
        color: #ea4242;
      }
      .fa-stack{
        margin-right: 5px;
        font-size: 12px;
      }
      span{
        font-size: 14px;
      }
    }
    .service-name{
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 15px;
      line-height: 18px;
    }
    .sub-info{
      color: #838d98;
      margin-bottom: 5px;
      line-height: 125%;
      font-size: 15px;
    }
  }
  .car-price{
    padding: 15px;
    text-align: right;

    .price{
      font-size: 32px;
      font-weight: 700;
      color: #212529!important;
      line-height: 1;
    }
    .appFees{
      font-size: 13px;
      color: #7a7a7a;
      margin-bottom: 5px;
    }
    .discount{
      justify-content: end;
      margin-bottom: 15px;
    }
    .old-price{
      font-size: 18px;
      margin-right: 8px;
      position: relative;
      color: #ccc;
      vertical-align: middle;
      text-decoration: line-through;
    }
    .dc-price{
      font-size: 13px;
      color: #fff;
      background: #d55556;
      padding: 2px 4px;
      vertical-align: middle;
      border-radius: 3px;
    }
    .dropoff-time{
      line-height: 1.1;
      font-size: 14px;
      color: #777;
    }
  }
}

.empty-service{
  color: #777;
  font-weight: 600;
  text-align: center;
  font-size: 18px;
}

@media only screen and (max-width: 641px) {
  .service-box{
    flex-direction: column!important;
    text-align: center;

    .car-img{
      max-width: 100%;
      display: inline-block;
    }
    .car-price{
      text-align: center;
      
      .discount{
        margin: 0 auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// MTechServices.vue?28036a2c